import React, { useEffect, useState } from "react";
import "./Services.css";
import { motion } from "framer-motion";
import PageOverView from "../../components/Page Overview/index.js";
import Breadcrumb from "../../components/BreadCrumb/index.js";


const features = [
    {
        title: "Component-Based Architecture",
        description: "Build reusable and maintainable UI components for complex applications.",
        imgUrl: "./img/services/reactjs/component-based-architecture.png",
    },
    {
        title: "Virtual DOM",
        description: "Enhance performance with a lightweight representation of the real DOM.",
        imgUrl: "./img/services/reactjs/virtual-dom.png",
    },
    {
        title: "State Management",
        description: "Effectively manage application state using hooks or libraries like Redux.",
        imgUrl: "./img/services/reactjs/state-management.png",
    },
    {
        title: "One-Way Data Flow",
        description: "Ensure predictable behavior with unidirectional data flow.",
        imgUrl: "./img/services/reactjs/one-way-dataflow.png",
    },
    {
        title: "Rich Ecosystem",
        description: "Leverage a vast library of tools, components, and extensions.",
        imgUrl: "./img/services/reactjs/rich-ecosystem.jpg",
    },
    {
        title: "SEO-Friendly Applications",
        description: "Optimize content delivery with server-side rendering and static generation.",
        imgUrl: "./img/services/reactjs/seo-friendly-applications.jpg",
    },
];


const ReactJSDevelopment = () => {
    const [, setScrollY] = useState(0);
    const paths = [
        { name: "Home", link: "/" },
        { name: "Services", link: "" },
        { name: "React.js Development", link: "" },
    ];

    const handleScroll = () => {
        setScrollY(window.scrollY);
    };

    useEffect(() => {
        window.scrollTo(0, 0);
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);

    return (
        <>
            <div className="page-overview">
                <PageOverView text="React.js Development" description="Build fast, scalable, and dynamic user interfaces with React.js, a leading JavaScript library." />
            </div>
            <motion.div
                key="div0"
                initial={{ opacity: 0, x: 100 }}
                animate={{ opacity: 1, x: 0 }}
                exit={{ opacity: 0, x: 100 }}
                transition={{ duration: 0.7 }}>
                <div className="service-page">
                    <div className="uiux-page">
                        <section className="about">
                            <h2>What is React.js?</h2>
                            <p>
                                React.js is a popular JavaScript library for building user interfaces, developed by Facebook.
                                It allows developers to create interactive and dynamic web applications efficiently.
                            </p>
                            <img
                                src="./img/services/reactjs.png"
                                alt="ReactJS Overview"
                                className="about-image"
                            />
                        </section>
                        <section className="services">
                            <h2>Our Key Services</h2>
                            <div className="services-grid">
                                {features.map((feature, index) => (
                                    <div className="service-card" key={index}>
                                        <img
                                            src={feature.imgUrl}
                                            alt={feature.title}
                                            className="service-img"
                                        />
                                        <h3>{feature.title}</h3>
                                        <p>{feature.description}</p>
                                    </div>
                                ))}
                            </div>
                        </section>
                        <section className="benefits">
                            <h2>Why Choose React.js?</h2>
                            <ul>
                                <li>Rapid development with reusable components</li>
                                <li>High performance through Virtual DOM</li>
                                <li>Wide community support and extensive resources</li>
                                <li>Scalability for applications of all sizes</li>
                            </ul>
                        </section>
                        <footer className="contact">
                            <h2>Ready to Develop with React.js?</h2>
                            <p>
                                Let our team of experts help you bring your ideas to life. <br /> Contact us at {" "}<a href="mailto:info@betajapansoftware.com">info@betajapansoftware.com</a>
                            </p>
                        </footer>
                    </div>
                </div>
            </motion.div>
            <div className="breadcrumb-container">
                <Breadcrumb paths={paths} />
            </div>
        </>
    );
};

export default ReactJSDevelopment;
